import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withTranslate } from 'react-redux-multilingual'
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { getnavData } from '../../../../actions/nav';
import { navMenuDefault } from '../../MangoIcons'

class NavBar extends Component {
  constructor() {
    super();

    this.state = {
      navClose: { right: '0px' },
      closeDiv : {display : 'block'}
    }
  }

  componentDidMount() {
    if (window.innerWidth < 750) {
      this.setState({ navClose: { right: '-410px' } })
    }
    if (window.innerWidth < 1199) {
      this.setState({ navClose: { right: '-300px' } })
    }
  
  const divEl = document.querySelector('#mainnav');


  divEl.addEventListener('mouseover', () => this.setState({closeDiv:{display:'block'}}));


    const { getnavData, connection_id, navData } = this.props;
    if (navData.length <= 0) {
      getnavData(connection_id);
    }
  }
  handleCloseDiv(){
    this.setState({
      closeDiv:{display:'none'}
    })
  }

  openNav() {
    
    this.setState({ navClose: { right: '0px' } })
  }
  closeNav() {
    this.setState({ navClose: { right: '-410px' } })
    // document.querySelector("#main-menu").classList.add("hover-unset");

  }

  onMouseEnterHandler() {
    if (window.innerWidth > 1199) {
      document.querySelector("#main-menu").classList.add("hover-unset");
    }
  }

  handleSubmenu = (event) => {
    if (event.target.classList.contains('sub-arrow'))
      return;

    if (event.target.nextElementSibling.classList.contains('opensubmenu'))
      event.target.nextElementSibling.classList.remove('opensubmenu')
    else {
      document.querySelectorAll('.nav-menu').forEach(function (value) {
        value.classList.remove('opensubmenu');
      });
      document.querySelector('.mega-menu-container').classList.remove('opensubmenu')
      event.target.nextElementSibling.classList.add('opensubmenu')
    }
  }

  handleMegaSubmenu = (event) => {
    event.preventDefault();
    if (event.target.classList.contains('sub-arrow'))
      return;

    if (event.target.parentNode.nextElementSibling.classList.contains('opensubmegamenu'))
      event.target.parentNode.nextElementSibling.classList.remove('opensubmegamenu')
    else {
      document.querySelectorAll('.menu-content').forEach(function (value) {
        value.classList.remove('opensubmegamenu');
      });
      event.target.parentNode.nextElementSibling.classList.add('opensubmegamenu')
    }
  }

  render() {
    const { navData,navDataLevel1Images,navDataLevel2Images,footerData,tenant_details } = this.props;
    const { translate } = this.props;
    const navItems = {'Orders Awaiting Acknowledgment' : 'awack','Order Acknowledge':'ack' ,'Pack Order':'pack'}
    // 
    // let dummyMen = {Men : {Shoes : [{SMH_LEVEL3_CD : 0, SMH_LEVEL3_DESC: 'Nothing here'}]}}
    // let dummyGirls = {Girls : {Jacket : [{SMH_LEVEL3_CD : 0, SMH_LEVEL3_DESC: 'Seriously, Nothing here as well'} ]}}
    // let dummyBoys = {Boys : {Shoes : [{SMH_LEVEL3_CD : 0, SMH_LEVEL3_DESC: 'Oh man! Dont you get it?'} ]}}
    // Object.assign(navData,dummyMen,dummyGirls, dummyBoys)
    return (
      <>
        <a href="javascript:void(0)" className="navbar-overlay" onClick={this.closeNav.bind(this)}></a>
        <div className="main-navbar">
          <div id="mainnav" >
            <div className="toggle-nav" onClick={this.openNav.bind(this)} >
              {/* <i className="fa fa-bars sidebar-bar"></i> */}
              <img src={navMenuDefault} className="icon-hovers" />
            </div>
            <ul className="nav-menu mobile-mega-menu" style={window.innerWidth < 567 ? {display:'flex',overflowX:'auto',flexWrap:'nowrap'}:{}} >
              <li className="back-btn" onClick={this.closeNav.bind(this)} style={{display:'none'}} >
                <div className="mobile-back text-right">
                  <span >Back</span>
                  <i className="fa fa-angle-right pl-2" aria-hidden="true"></i>
                </div>
              </li>
{
               Object.entries(navItems).map(([iname, ilink]) => {
                  return(  <li className="mega-menu">
                      <Link to={ilink} onClick={() => this.closeNav()} >
                       {iname}
                      </Link>

                      
                    </li> )})
                    
                    }
                   
                   {tenant_details['STE_ECOM_BRAND_NAME'] !== 'Giant' ? '' : 
                   <li className="mega-menu" style={window.innerWidth > 567 ? {padding:10 ,textAlignLast:'center'}: {padding:10 ,textAlignLast:'center',flex:'0 0 auto'}}>
<Link to='#'> More</Link>
<div style={this.state.closeDiv} >
<div className="mega-menu-container" style={window.innerWidth > 567 ? {padding:10,position:'absolute',left:0,backgroundColor:'#f5f5f5',width:'100%'/*,boxShadow: '0 8px 10px rgb(0 0 0 / 10%)'*/} : 
         {padding:0,position:'absolute',left:0,backgroundColor:'#f5f5f5',width:'100%'/*,boxShadow: '0 8px 10px rgb(0 0 0 / 10%)'*/}} >
           <div className="container" style={{padding:10,maxWidth:'fit-content',float:'left'}} >
             <div className="row mobile-mega-menu" style={window.innerWidth > 567 ? {  }:{display:'flex',overflowX:'auto',flexWrap:'nowrap' }}>


{ footerData && footerData!== undefined ? 

Object.keys(footerData).map(key => {
if(key !== 'AboutUs') {
return (
<div className="col mega-box" >

<div className="link-section">  <div className="menu-title" >
{key !== 'AboutUs' &&
<Link to={`/faq/${key}`} style={{color:'black'}} onClick={() => this.handleCloseDiv()}>
<h5> {key}</h5>
</Link> }
</div></div></div>

)
}
}) :'' }

             </div>
             </div></div>
             </div>
 </li>
  }
  
              
              

            </ul>
          </div>
        </div>
      </>
    ) 
   
  }
}


const mapStateToProps = (state) => ({
  presentURL: state.tenant.presentURL,
    footerData : state.landing.faqContent || {},
    tenant_details : state.tenant.tenant_details,
  navLoading: state.nav.loading,
  navError: state.nav.error,
  navData: state.nav.navData,
  navDataLevel1Images : state.nav.navDataLevel1Images,
  navDataLevel2Images : state.nav.navDataLevel2Images,
  connection_id: state.tenant.connection_id
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getnavData,
}, dispatch)

export default withTranslate(connect(mapStateToProps, mapDispatchToProps)(NavBar));
// export default withTranslate(NavBar);